import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-firstnet-signup-utf-modal',
    templateUrl: './firstnet-signup-utf-modal.component.html',
    styleUrls: ['./firstnet-signup-utf-modal.component.scss'],
    standalone: false
})
export class FirstnetSignupUtfModalComponent extends CfetBaseComponent {
  @Input() openModal: string;
  @Output() closeModal = new EventEmitter<any>();

  constructor() {
    super();
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
    }
  }
  continue(event: any, modalAction: string) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
    }
  }
}
